import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'otconsent'
})
export class OtconsentPipe implements PipeTransform {

  transform(items: any[], searchText: string) {
    return items ? items.filter(item => item.documentName.search(new RegExp(searchText, 'i')) > -1) : [];
    }

}
